import { BaseController } from '../../../../common/base/controller';
import { AutofillableCreditors, SuggestSettings } from './directDebitForm.constants';

export class DirectDebitFormController extends BaseController {
  constructor(
    $scope,
    controllerService,
    inputFormService,
    creditorsService,
    directDebitFormFields,
    PaymentPartnersSuggestTemplate
  ) {
    'ngInject';
    super({
      $scope,
      controllerService,
      inputFormService,
      creditorsService,
      directDebitFormFields,
      PaymentPartnersSuggestTemplate
    });
  }

  get labelPrefix() {
    return 'app.ticket.finances.';
  }

  get autofillableCreditors() {
    return AutofillableCreditors;
  }

  get paymentPartnerSuggest() {
    const settings = angular.copy(SuggestSettings);
    settings.templateUrl = this.PaymentPartnersSuggestTemplate;
    settings.src = this.suggestPaymentPartnerSource.bind(this);
    settings.select = this.suggestPaymentPartnerSelect.bind(this);
    return settings;
  }

  get creditorIdSuggest() {
    const settings = angular.copy(SuggestSettings);
    settings.templateUrl = this.PaymentPartnersSuggestTemplate;
    settings.src = this.suggestCreditorIdSource.bind(this);
    settings.select = this.suggestCreditorIdSelect.bind(this);
    return settings;
  }

  $onInit() {
    this.bindEvents();

    // Initialize fields when language options has been loaded
    this.setLanguageOptions().then(() => this.setupFields());
  }

  bindEvents() {
    const { $scope } = this;
    $scope.$on('directDebits.setupFields', (e, values) => this.setupFields(values));
  }

  setupFields(values) {
    // Flag to identify if the fields are already initialized
    const initialSetup = !this.fields;

    // Initialize fields when language options has been loaded
    this.fields = this.inputFormService.getFields(
      angular.copy(this.directDebitFormFields),
      this.languageOptions,
      this.model
    );

    // Set suggestable fields only once (on their initial setup)
    if (initialSetup) {
      this.fields.filter(field => {
        if (field.type === 'suggest' && angular.isString(field.suggest)) {
          field.suggest = angular.copy(this[field.suggest]);
        }
      });
    }

    // Set prefill values into the fields
    if (values) {
      this.populateFields(values);
    }
  }

  populateFields(item) {
    this.$timeout(() => {
      this.model = item;
    });
  }

  suggestPaymentPartnerSource(viewValue) {
    return this.creditorsService.find(viewValue);
  }

  suggestPaymentPartnerSelect($item) {
    this.$timeout(() => {
      const { creditorId, name } = $item;
      this.model.creditorId = creditorId;
      this.model.name = name;
      this.prefillCreditor(creditorId);
    });
  }

  suggestCreditorIdSource(viewValue) {
    // Try to autocorrect value
    viewValue = this.creditorsService.autocorrectCreditorId(viewValue);
    return this.creditorsService.suggestCreditorId(viewValue);
  }

  suggestCreditorIdSelect($item) {
    this.$timeout(() => {
      const { creditorId, name } = $item;
      this.model.creditorId = creditorId;
      this.model.name = name;
      this.prefillCreditor(creditorId);
    });
  }

  /**
   * Some online payment creditors don't need/have a purpose and mref
   * so we need to prefill those fields with a simple dash since the
   * fields are required.
   */
  prefillCreditor(creditorId) {
    if (!creditorId || this.autofillableCreditors.indexOf(creditorId.toUpperCase()) === -1) {
      return;
    }
    this.model.purpose = '-';
    this.model.mref = '-';
  }
}
